// hooks/useLogonPermissionCheck.js
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from 'store/features/auth/authSlice';

const useLogonPermissionCheck = () => {
  const dispatch = useDispatch();
  const userId = useSelector(state => state.auth.user?.id);
  const token = process.env.REACT_APP_TOKEN;

  useEffect(() => {
    const checkAccountStatus = async () => {
      if (!userId) return;

      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}qwikITUser/${userId}`,
          {
            method: 'GET',
            headers: {
              'Authorization': `${token}`,
              'Content-Type': 'application/json',
            },
          }
        );

        if (response.ok) {
          const userData = await response.json();

          // Check if account status is false
          if (userData.account_status === false) {
            console.log('Account disabled, logging out...');
            dispatch(logout());
            window.location.href = '/login'; // Redirect to login page
            return;
          }
        }
      } catch (error) {
        console.error('Error checking account status:', error);
      }
    };

    // Check on initial load
    checkAccountStatus();

    // Set up interval to check periodically (every 5 minutes)
    const intervalId = setInterval(checkAccountStatus, 5 * 60 * 1000);

    return () => clearInterval(intervalId);
  }, [userId, token, dispatch]);

  return null;
};

export default useLogonPermissionCheck;